import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

// ---- Same tokens as HomeBoldSunset.jsx ---------------------------------
const COLORS = {
  bg: "#200A08",
  surface: "#341210",
  ink: "#FBEDE2",
  muted: "#C9A79B",
  orange: "#FF7A33",
  gold: "#FFC93C",
  teal: "#2EC4B6",
};

const FONT_DISPLAY = '"Arial Black", "Helvetica Neue", Arial, sans-serif';
const FONT_MONO = 'ui-monospace, "Cascadia Code", "SFMono-Regular", Menlo, monospace';

const LINKS = [
  { label: "Inicio", to: "/" },
  { label: "Sobre mí", to: "/about" },
  { label: "Proyectos", to: "/projects" },
  { label: "Blog", to: "/blogList" },
  { label: "Contacto", to: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav
      style={{ background: COLORS.surface, borderBottom: `2px solid ${COLORS.teal}` }}
      className="sticky top-0 z-50"
    >
      <style>{`
        .nav-link { position: relative; transition: color 0.2s ease; }
        .nav-link::after {
          content: '';
          position: absolute;
          left: 0; bottom: -4px;
          height: 2px; width: 0;
          background: ${COLORS.orange};
          transition: width 0.2s ease;
        }
        .nav-link:hover::after { width: 100%; }
      `}</style>

      <div className="container mx-auto flex justify-between items-center px-4 md:px-8 py-4">
        {/* Logo */}
        <Link
          to="/"
          style={{ fontFamily: FONT_DISPLAY, color: COLORS.ink }}
          className="text-lg md:text-xl uppercase tracking-tight"
        >
          Julio Muñoz <span style={{ color: COLORS.orange }}>→</span>
        </Link>

        {/* Desktop links */}
        <ul className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                style={{ fontFamily: FONT_MONO, color: COLORS.muted, letterSpacing: "0.08em" }}
                className="nav-link text-sm uppercase"
                onMouseEnter={(e) => (e.currentTarget.style.color = COLORS.ink)}
                onMouseLeave={(e) => (e.currentTarget.style.color = COLORS.muted)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((v) => !v)}
          style={{ color: COLORS.ink }}
          className="md:hidden"
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <ul
          style={{ background: COLORS.bg, borderTop: `1px solid ${COLORS.teal}` }}
          className="md:hidden flex flex-col px-4 pb-4"
        >
          {LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                onClick={() => setOpen(false)}
                style={{ fontFamily: FONT_MONO, color: COLORS.muted, letterSpacing: "0.08em" }}
                className="block py-3 text-sm uppercase"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;